import React from "react";
import classNames from "classnames";
import { TbAlertCircle } from "react-icons/tb";
import { IoIosClose } from "react-icons/io";

import { AlertProps } from "./types";

import "./styles.scss";

export const Alert = ({ text, maxWidth, className, icon, type, closable, style }: AlertProps) => {
  const [closeAlert, setCloseAlert] = React.useState(false);
  if (closeAlert) return null;

  const classnames = classNames(`Alert`, {
    [`Alert--${className}`]: className,
    "Alert--warning": type === "warning",
    "Alert--info": type === "info",
    "Alert--success": type === "success",
    "Alert--error": type === "error",
    "Alert--default": type === "default",
  });

  if (icon === "warning") {
    icon = <TbAlertCircle aria-label="alert-icon" />;
  }

  const handleClose = () => {
    setCloseAlert(true);
  };

  return (
    <div
      data-testid="Alert"
      className={classnames}
      style={{ maxWidth: maxWidth || "100%", ...style }}>
      <div className="Alert--left">
        {icon && icon}
        {text && <span className="Alert__text">{text}</span>}
      </div>
      {closable && (
        <button
          className="Alert__close-button"
          onClick={handleClose}
          aria-label="Close alert">
          <IoIosClose style={{ margin: 0 }} />
        </button>
      )}
    </div>
  );
};
